var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"transaction-success-message-view"},[_c('transaction-success-message',_vm._b({attrs:{"card-off":"","continue-to-is-route":""}},'transaction-success-message',_vm.params,false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }